import auth from '@/services/auth/authService'

export default {
  isUserLoggedIn: () => {
    const isAuthenticated = !!auth.isAuthenticated()
    return auth.user() && isAuthenticated
  },
}
